import L from 'leaflet'
import MapObject from '@/models/MapObject'

export const ShapeTypes = {
    CIRCLE: 'circle',
    LINE: 'line',
    POLYGON: 'polygon',
}

export class MapShape extends MapObject {
    defaults() {
        const defaults = super.defaults()
        defaults.settings.collapsed = false
        defaults.object_name = 'MapShape'
        return defaults
    }

    isCollapsed() {
        return this.getSetting('collapsed')
    }

    setCollapsed(value) {
        this.updateSettingQueued('collapsed', value)
    }

    getAllLatLongs() {
        const bounds = this.points.map((p) => L.latLng(p.latitude, p.longitude))

        // A circle has only one point, so we need to add some fake ones to account for its radius
        // Quick & dirty meters => lat/lng conversation from https://bit.ly/3ea2wPG
        if (this.type === ShapeTypes.CIRCLE) {
            const radiusLat = this.getRadius() / 111111
            const radiusLng = (this.getRadius() / 111111) * Math.cos(radiusLat)
            const center = bounds[0]
            bounds.push([center.lat + radiusLat, center.lng + radiusLng])
            bounds.push([center.lat - radiusLat, center.lng - radiusLng])
        }

        return bounds
    }

    getPolygonPoints() {
        return this.points.map((p) => [p.latitude, p.longitude])
    }

    getRadius() {
        if (this.type === ShapeTypes.CIRCLE) {
            return this.points[0].radius
        }

        return 0
    }
}
